import { ScheduledFarmItemTypes } from '@ourbranch/lookups';

// NOTE: this list governs which fields show on a scheduled Coverage F item. It is intentionally
// NOT the same set as THRESHOLD_MACHINERY_CATEGORIES in packages/underwriting-rules/src/carriers/
// cfm/post-data-rules/farm-post-data-rules.ts (which excludes IRRIGATION_EQUIPMENT and
// RENTED_OR_BORROWED_EQUIPMENT because it drives the CFM $250k policy-wide exposure threshold,
// #33318). Keep the two divergent — do not "sync" one to the other.
export const MACHINERY_CATEGORIES = [
  ScheduledFarmItemTypes.COMBINES,
  ScheduledFarmItemTypes.CUSTOM_FARM_MACHINERY,
  ScheduledFarmItemTypes.DESCRIBED_MACHINERY,
  ScheduledFarmItemTypes.IRRIGATION_EQUIPMENT,
  ScheduledFarmItemTypes.MACHINERY_NOT_DESCRIBED,
  ScheduledFarmItemTypes.RENTED_OR_BORROWED_EQUIPMENT
];

export const OPEN_PERILS_CATEGORIES = [
  ScheduledFarmItemTypes.COMBINES,
  ScheduledFarmItemTypes.DESCRIBED_MACHINERY,
  ScheduledFarmItemTypes.IRRIGATION_EQUIPMENT
];

export const RCC_CATEGORIES = [
  ScheduledFarmItemTypes.COMBINES,
  ScheduledFarmItemTypes.DESCRIBED_MACHINERY,
  ScheduledFarmItemTypes.IRRIGATION_EQUIPMENT
];
